module.exports = __webpack_public_path__ + "static/media/carlysh_carlysh-R2-026-11A.603126a5.jpg";